import PaymentPlanOption from './PaymentPlanOption';

export default PaymentPlanOption;
